import React from "react";

// Light-themed pagination bar for the Tailwind card/table pages. The existing
// Table/Pagination.jsx is styled for the dark sidebar background, so it can't
// be reused here.
export default function TablePagination({ page, setPage, totalItems, pageSize }) {
  const maxPage = Math.max(1, Math.ceil(totalItems / pageSize));
  if (totalItems <= pageSize) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalItems);

  const btn =
    "px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium bg-white " +
    "hover:bg-gray-50 disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-white";

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mt-3">
      <span className="text-sm text-gray-600">
        Showing <span className="font-semibold">{from}</span>–
        <span className="font-semibold">{to}</span> of{" "}
        <span className="font-semibold">{totalItems}</span>
      </span>
      <div className="flex items-center gap-2">
        <button type="button" className={btn} disabled={page === 1} onClick={() => setPage(1)}>
          First
        </button>
        <button
          type="button"
          className={btn}
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Previous
        </button>
        <span className="px-3 py-2 text-sm text-gray-700">
          Page <span className="font-semibold">{page}</span> of{" "}
          <span className="font-semibold">{maxPage}</span>
        </span>
        <button
          type="button"
          className={btn}
          disabled={page >= maxPage}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
        <button
          type="button"
          className={btn}
          disabled={page >= maxPage}
          onClick={() => setPage(maxPage)}
        >
          Last
        </button>
      </div>
    </div>
  );
}
